import { useEffect, useState } from "react";
import {
  getConfigOverrides,
  isConfigOverrideAllowed,
} from "../../utils/configOverrides";
import "./ConfigOverrideBanner.scss";

export function ConfigOverrideBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!isConfigOverrideAllowed()) {
      setShowBanner(false);
      return;
    }

    const overrides = getConfigOverrides();
    setShowBanner(!!overrides);
  }, []);

  if (!showBanner) return null;

  return (
    <div className="config-override-banner">
      <span className="banner-icon">⚠️</span>
      <span className="banner-text">
        Config overrides active - Check console for details
      </span>
    </div>
  );
}
